import { THEME } from './constants/theme';
import { THEME_BREAKPOINT_NAMES } from './enums/breakpoints';
import {
  THEME_COLOR_NAMES,
  THEME_COLOR_SHADE_NAMES,
  THEME_COLOR_TYPE_NAMES
} from './enums/colors';
import { THEME_DEVICE_NAMES } from './enums/devices';
import {
  THEME_TYPOGRAPHY_ATTRIBUTE_NAMES,
  THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES,
  THEME_TYPOGRAPHY_VARIANT_NAMES
} from './enums/typography';

const BREAKPOINTS = Object.values(THEME_BREAKPOINT_NAMES);

const COLORS = Object.values(THEME_COLOR_NAMES);
const COLOR_TYPES = Object.values(THEME_COLOR_TYPE_NAMES);
const COLOR_SHADES = Object.values(THEME_COLOR_SHADE_NAMES);

const TYPOGRAPHY_VARIANTS = Object.values(THEME_TYPOGRAPHY_VARIANT_NAMES);
const FONT_WEIGHTS = Object.values(THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES);
const FONT_ATTRIBUTES = Object.values(THEME_TYPOGRAPHY_ATTRIBUTE_NAMES);

const DEVICES = Object.values(THEME_DEVICE_NAMES);

/**
 * @name getStaticBreakpoints
 * @description helper
 * @param {string} name
 * @param {any} theme
 * @returns {number | any}
 */
export function getStaticBreakpoints(name, theme = THEME) {
  if (!BREAKPOINTS.includes(name)) {
    console.warn(`Warning - "${name}" isn't a valid breakpoint!`);
  }

  return theme.breakpoints[name] || theme.breakpoints;
}

/**
 * @name getStaticColors
 * @description helper
 * @param {string} name
 * @param {string} shade
 * @param {any} theme
 * @returns {string | any}
 */
export function getStaticColors(
  name,
  shade = THEME_COLOR_SHADE_NAMES.MAIN,
  theme = THEME
) {
  if (!COLORS.includes(name)) {
    console.warn(`Warning - "${name}" isn't a valid color!`);
  }

  if (![...COLOR_SHADES, ...COLOR_TYPES].includes(shade) && isNaN(shade)) {
    console.warn(`Warning - "${shade}" isn't a valid color shade!`);
  }

  return theme.colors[name] && (
    theme.colors[name][shade] ?? theme.colors[name]
  ) || theme.colors;
}

/**
 * @name getStaticIcons
 * @description helper
 * @param {string} name
 * @param {any} theme
 * @returns {string | any}
 */
export function getStaticIcons(name, theme = THEME) {
  return theme.icons[name] || theme.icons;
}

/**
 * @name getStaticTypography
 * @description helpers
 * @param {string} name
 * @param {string} weight
 * @param {string} attr
 * @param {string} device
 * @param {any} theme
 * @returns {string | number}
 */
export function getStaticTypography(
  name,
  weight,
  attr,
  device = THEME_DEVICE_NAMES.DESKTOP,
  theme = THEME
) {
  if (!TYPOGRAPHY_VARIANTS.includes(name.replace(/(-[\w]+)/g, ''))) {
    console.warn(`Warning - "${name}" isn't a valid variant!`);
  }

  if (!FONT_WEIGHTS.includes(weight)) {
    console.warn(`Warning - "${weight}" isn't a valid weight!`);
  }

  if (!FONT_ATTRIBUTES.includes(attr) && attr) {
    console.warn(`Warning - "${attr}" isn't a valid font attribute!`);
  }

  if (!DEVICES.includes(device)) {
    console.warn(`Warning - "${device}" isn't a valid device!`);
  }

  const fontCSSRule = weight && theme.typography[name][weight] && (
    theme.typography[name][weight][attr] ?? theme.typography[name][weight]
  ) || theme.typography[name];

  const deviceCSSRule = device && theme.typography[name][device] && (
    theme.typography[name][device][attr] ?? theme.typography[name][device]
  ) || theme.typography[name];

  return theme.typography[name] && ({
    ...fontCSSRule,
    ...deviceCSSRule,
  }) || theme.typography;
}
